import { User } from "shared/models/site/user";

import { User as OIDCUser } from 'oidc-client';



export const userMapper = {
    mapFromOIDCUser: (oidcUser: OIDCUser): User => ({
        name: oidcUser.profile.name,
        roles: oidcUser.profile.role,
        expires_in: oidcUser.expires_in,
        access_token: oidcUser.access_token
    })
}